import styled from 'styled-components';

export const QuestionHeader = styled.h2`
    font-family: 'Roboto', Verdana, Arial, sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 1.3125em;
    color: ${props => props?.errors?.includes(props?.question?.QuestionCode) ? props.theme.errorText : props.theme.textPrimary};
    ${props => props?.padding && `padding: ${props?.padding};`}
    margin-top: ${props => props?.marginTop ? props.marginTop : '1em'};
    ${props => props?.marginRight && `margin-right: ${props?.marginRight}`}
    transition: color 0.3s ease;
    & .text-bold {
        font-weight: 700;
    }
`;

export const QuestionHead = styled.h2`
    font-family: 'RobotoRegular', Verdana, Arial, sans-serif;
    font-weight: normal;
    font-style: italic;
    font-size: 13.6px;
    color: ${props => props.theme.textSecondary};
    ${props => props?.padding && `padding: ${props.padding};`}
    transition: color 0.3s ease;
`;